import { useMutation } from "@tanstack/react-query";
import { contactImportApi } from "service/crm/api/contactImport";
import { ContactImportRecord } from "types/crm/contactImport";

/**
 * Triggers the backend validation process for a contact import.
 */
export const useValidateContactImportMutation = () =>
  useMutation<ContactImportRecord, unknown, string>({
    mutationFn: contactImportApi.validateImport,
  });
